import { motion } from "framer-motion";
import { itemUp } from "../Utils/framerMotionVariants";
import { Certification } from "../data/certifications";

const CertificationCard: React.FC<{ certification: Certification }> = ({
  certification,
}) => {
  return (
    <motion.div
      variants={itemUp}
      className="bg-white/10 p-6 rounded-xl shadow-lg backdrop-blur-sm"
    >
      <div>
        <h3 className="font-medium">
          <a
            href={certification.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {certification.title}
          </a>
        </h3>
        <p className="text-sm text-gray-300">{certification.institute}</p>
        <p className="text-sm text-gray-400">{certification.issued}</p>
      </div>
    </motion.div>
  );
};

export default CertificationCard;
